import { routenames } from '@/router/routenames';
import type { NavigationEntryRaw } from '../types';

export const workManagementNavigationRaw: NavigationEntryRaw[] = [
  {
    titleI18n: 'JobOccurrence_other',
    route: { name: routenames.jobOccurrences.index },
  },
  {
    titleI18n: 'JobConfiguration_other',
    route: { name: routenames.jobConfigurations.index },
  },
];
